/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import FormErrorMessage from "../ErrorMessage";

const CustomController = ({
  control,
  name,
  render,
  showError = true,
  error,
  messages,
  data,
  position,
  className,
  ...props
}) => {
  return (
    <>
      <Controller
        {...props}
        name={name}
        render={render}
        control={control}
        defaultValue={
          data?.value?.toString() == "" ? "" : data?.value?.toString()
        }
      />
      {}
      {showError && <FormErrorMessage className={className} error={error} messages={messages} position={position}/>}
    </>
  );
};

export default CustomController;
